/**
 * TypeScript类型工具集
 *
 * 提供高级类型推断和类型安全的工具类型
 */
import { Component } from '../ECS/Component';
/**
 * 组件类型守卫
 */
export function isComponentType(value) {
    return typeof value === 'function' && value.prototype instanceof Component;
}
/**
 * 类型安全的组件数组守卫
 */
export function isComponentArray(value) {
    return value.every(isComponentType);
}
//# sourceMappingURL=TypeHelpers.js.map